/**
 * The address fields shared by a service location and the preliminary address
 * an account carries before its location is resolved.
 */
type AddressParts = {
  address_1?: string | null;
  address_2?: string | null;
  city?: string | null;
  state?: string | null;
  postal_code?: string | null;
};

function formatCityLine(address: AddressParts): string {
  return (
    [address.city, address.state].filter(Boolean).join(", ") +
    (address.postal_code ? ` ${address.postal_code}` : "")
  );
}

export function formatAddressWithoutJoining(address: AddressParts): string[] {
  return [address.address_1, address.address_2, formatCityLine(address)].filter(
    (line): line is string => Boolean(line),
  );
}
